import {
  IsString,
  IsNumber,
  IsOptional,
  IsPositive,
  Min,
  Max,
  IsNotIn,
} from "class-validator";

export class AwardPointsDto {
  @IsString()
  user_id: string;

  @IsString()
  club_id: string;

  @IsNumber()
  @IsNotIn([0]) // Points cannot be zero
  @Min(-500000) // Max 500,000 points can be removed (=$500)
  @Max(500000) // Max 500,000 points can be awarded (=$500)
  points: number;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  source?: string;

  @IsString()
  @IsOptional()
  object_id?: string;

  @IsString()
  @IsOptional()
  object_type?: string;
}

export class RedeemPointsDto {
  @IsString()
  club_id: string;

  @IsNumber()
  @IsPositive()
  @Min(1)
  points: number;

  @IsString()
  object_id: string;

  @IsString()
  object_type: string;

  @IsString()
  transaction_id: string;
}

export class UpdateTransactionDto {
  @IsOptional()
  @IsNumber()
  @IsNotIn([0]) // Points cannot be zero
  @Min(-500000) // Max 500,000 points can be removed (=$500)
  @Max(500000) // Max 500,000 points can be awarded (=$500)
  points?: number;

  @IsOptional()
  @IsString()
  description?: string;
}
